import { linkAccountResp } from '@biz-models/network/account-model-network';
import { createActionGroup, emptyProps } from '@ngrx/store';

export const ProviderAccount = createActionGroup({
	source: 'Provider Account',
	events: {
		GetProviderList: emptyProps(),
		GetProviderListSuccess: (payload: linkAccountResp[]) => ({ payload }),
		GetProviderListFail: (payload: string) => ({ payload }),
	},
});
